export default __webpack_public_path__ + "static/media/mp_exit.6eec0463.svg";